import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseComponent, MyClaim, NotificationItem } from 'src/app/shared';
import {
  ClaimService,
  CommCenterService,
  ConfigurationService,
  DisplayService,
  InpageAliasService,
  LogService,
  Session,
  UserRoleService,
  DynamicEventBindService,
} from '../..';
import { Reminder } from '../../../shared/models/reminder';
import { OutboundSSO, UserActions } from '../../../shared/models/user';
import { UserActionService } from '../../../shared/services/user-action.service';
import { OutboundSsoService } from '../../services/outbound-sso.service';
import { LeaveLinkAccessService } from '../../services/leavelink-access.service';
import { IClaimant } from '../labels/claimant-label.component';
import { ReportNewClaimComponent } from '../report-new-claim/report-new-claim.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { Aliases } from '../../models/aliases';

@Component({
    selector: 'app-reminders',
    template: `
    <div #dynamicContentContainer1>
      <app-loading-panel [state]="!myclaimsLoaded ? 'Loading' : 'Loaded'">
        <ng-template #content>
          <!-- mobile view -->
          <div
            class="tw-items-start tw-w-full tw-flex tw-flex-wrap lg:tw-hidden"
          >
            <div class="tw-w-full">
              <ng-container *ngTemplateOutlet="reminders"></ng-container>
            </div>
            <div class="tw-w-full">
              <ng-container *ngTemplateOutlet="links"></ng-container>
            </div>
          </div>
          <!-- mobile view end -->

          <div class="tw-items-start tw-w-full tw-hidden lg:tw-flex app-pt2">
            <div class="app-pr2 tw-flex-none">
              <img [src]="imageName" width="194" height="193" alt="" />
            </div>
            <div class="app-pr2 app-pl3 tw-grow">
              <ng-container *ngTemplateOutlet="reminders"></ng-container>
            </div>
            <div class=" side-border app-pr3 app-pb2">
              <ng-container *ngTemplateOutlet="links"></ng-container>
            </div>
          </div>
          <ng-template #reminders>
            <app-loading-panel
              loadingStyle="Image"
              loadingImageSrc="/assets/images/loader/my-claims-ghost.svg"
              [state]="isLoaded ? 'Loaded' : 'Loading'"
            >
              <ng-template #content>
                <div class="tw-w-full">
                  <span style="font-weight: bold;font-size: 18px"
                    >{{'Hello'| translation : translationRequest}} {{ currentUserName | titlecase }},
                  </span>
                  <span
                    #dynamicContentContainer1
                    style="font-weight: normal;font-size: 18px"
                    [innerHtml]="
                      activitiesMyClaims.employeeReminderHeader | safeHtml
                    "
                  ></span>
                </div>
                <ul
                  role="list"
                  class="tw-list-disc app-pl3 app-pt2 reminder-list"
                  *ngFor="let rmdr of activitiesMyClaims.reminder"
                >
                  <li
                    role="listitem"
                    class="list-item"
                    *ngIf="
                      rmdr.alertType !== 'PaymentAlert' &&
                      rmdr.alertType !== 'CLINICAL_REVIEW_SENT_A' &&
                      rmdr.alertType !== 'INVENTORY_UNSUBMITTED' &&
                      rmdr.firstText !== '' &&
                      rmdr.firstText !== undefined
                    "
                  >
                    {{ rmdr.firstText}}
                    <a
                      role="button"
                      tabindex="0"
                      (click)="
                        getClaimDetails(
                          rmdr.alertType,
                          rmdr.importantRemainders?.length
                        )
                      "
                      (keydown.enter)="
                        getClaimDetails(
                          rmdr.alertType,
                          rmdr.importantRemainders?.length
                        )
                      "
                      >{{ rmdr.linkText  }}</a
                    >
                    {{ rmdr.lastText }}
                  </li>
                  <li
                    role="listitem"
                    class="list-item"
                    *ngIf="rmdr.alertType === 'CLINICAL_REVIEW_SENT_A'"
                  >
                    <a
                      role="button"
                      tabindex="0"
                      (click)="
                        getClaimDetails(
                          rmdr.alertType,
                          rmdr.importantRemainders?.length
                        )
                      "
                      (keydown.enter)="
                        getClaimDetails(
                          rmdr.alertType,
                          rmdr.importantRemainders?.length
                        )
                      "
                      >{{ rmdr.linkText }}</a
                    >
                    {{ rmdr.lastText }}
                  </li>
                  <li
                    role="listitem"
                    class="list-item"
                    *ngIf="rmdr.alertType === 'INVENTORY_UNSUBMITTED'"
                  >
                    {{ rmdr.firstText }}
                    <a
                      class="app-color-teal tw-font-bold"
                      role="link"
                      tabindex="0"
                      (click)="openClaimSummary(rmdr)"
                      (keydown.enter)="openClaimSummary(rmdr)"
                    >{{ rmdr.importantRemainders?.[0]?.claimNumber }}</a>
                    {{ rmdr.middleText }}
                    <a
                      class="app-color-teal tw-font-bold"
                      role="link"
                      tabindex="0"
                      (click)="openInventoryReminder(rmdr)"
                      (keydown.enter)="openInventoryReminder(rmdr)"
                    >{{ rmdr.linkText }}</a>
                    {{ rmdr.lastText }}
                  </li>
                  <li
                    role="listitem"
                    class="list-item"
                    *ngIf="rmdr.alertType === 'PaymentAlert' && showPaymentAlert"
                  >
                    {{ rmdr.notificationMessage}}
                  </li>
                </ul>
              </ng-template>
            </app-loading-panel>
          </ng-template>

          <ng-template #links>
            <ng-content *ngIf="outboundSSO !== undefined && outboundSSO !== null && outboundSSO.length > 0">
            <div
              class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
              *ngFor="let outbound of outboundSSO"
            >
              <img
                *ngIf="outbound.ssoLinkEmployee"
                [src]="outbound.ssoLinkImage"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />

              <a
                *ngIf="outbound.ssoLinkEmployee"
                tabindex="0"
                class="big-link app-pl1"
                (click)="quickLinksClick('OutboundSSO', 'Outbound SSO',outbound.ssoType)"
                (keydown.enter)="quickLinksClick('OutboundSSO', 'Outbound SSO',outbound.ssoType)"
                >{{ outbound.ssoLinkEmployee | translation: translationRequest }}</a
              >
            </div>
            </ng-content>
            <div
              class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
              *ngIf="hasReportClaim && !terminated"
            >
              <img
                src="./assets/images/Report_claim.png"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />
              <a
                class="big-link app-pl1"
                role="button"
                (click)="quickLinksClick('ReportNewClaim', 'Report New Claim')"
                (keydown.enter)="
                  quickLinksClick('ReportNewClaim', 'Report New Claim')
                "
                tabindex="0"
                >{{ reportClaimLabel }}</a
              >
            </div>
            <div
              *ngIf="showReportAbsence()"
              class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
            >
              <img
                src="./assets/images/svgicons/Intermittent_absence.svg"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />
              <a
                class="big-link app-pl1"
                (click)="quickLinksClick('ReportAbsence', 'Report an Absence')"
                (keydown.enter)="
                  quickLinksClick('ReportAbsence', 'Report an Absence')
                "
                role="button"
                tabindex="0"
                >{{'Report an absence' | translation : translationRequest | sentenceCase}}</a
              >
            </div>
            <div
              class="tw-flex tw-items-center app-pt1 "
              *ngIf="incidentalAbsences5"
            >
              <img
                src="./assets/images/Intermittent_absence.png"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />
              <a
                tabindex="0"
                class="big-link app-pl1"
                (click)="quickLinksClick('ViewAbsences', 'View Absence')"
                (keydown.enter)="
                  quickLinksClick('ViewAbsences', 'View Absence')
                "
                >{{'View absences'| translation : translationRequest | sentenceCase}}</a
              >
            </div>
            <div
              class="tw-flex tw-items-center app-pt1 tw-cursor-pointer"
              *ngIf="hasClaims"
            >
              <img
                src="./assets/images/Comm_center_icon.png"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />
              <a
                tabindex="0"
                (click)="
                  quickLinksClick('CommunicationCenter', 'Communication Center')
                "
                (keydown.enter)="
                  quickLinksClick('CommunicationCenter', 'Communication Center')
                "
                role="link"
                class="big-link app-pl1 mat-badge-accent"
                [matBadge]="commCenterService.unreadMessageCount()"
                matBadgeOverlap="false"
                >{{'Communication center'| translation : translationRequest | sentenceCase}}</a
              >
            </div>
            <div
              class="tw-flex tw-items-center app-pt1 "
              *ngIf="hasLearningCenter"
            >
              <img
                src="./assets/images/Helpful_resources_icon.png"
                height="30"
                width="30"
                class="tw-hidden lg:tw-block"
                alt=""
              />
              <a
                tabindex="0"
                class="big-link app-pl1"
                (click)="quickLinksClick('LearningCenter', 'Learning Center')"
                (keydown.enter)="
                  quickLinksClick('LearningCenter', 'Learning Center')
                "
                >{{'Helpful resources'| translation : translationRequest | sentenceCase}}</a
              >
            </div>
          </ng-template>
        </ng-template></app-loading-panel
      >
      <ng-template #dialogSelectClaim>
        <app-dialog
          [showActions]="false"
          [showHeader]="false"
          ariaLabel="{{'Select claim dialog'| sentenceCase }}"
          ariaLabelMessage="{{'Close announcement popup' | sentenceCase}}"
        >
          <app-claim-list-report-absence
            title="{{'Confirmation'| translation : translationRequest | sentenceCase}}"
            [claims]="myClaims"
            [redirectToSmartly]="redirectToSmartly"
          >
          </app-claim-list-report-absence>
        </app-dialog>
      </ng-template>
      <ng-template #dialogReportNewClaim>
        <app-dialog
          title="{{'Confirmation'| sentenceCase}}"
          ariaLabel="{{'Confirmation dialog'| sentenceCase}}"
          [showActions]="false"
          [showHeader]="false"
          ariaLabelMessage="{{'Close announcement popup'| sentenceCase}}"
        >
          <app-claim-list-report-absence
            [claims]="this.myClaims"
            [showContinue]="true"
            [redirectToSmartly]="true"
          ></app-claim-list-report-absence>
        </app-dialog>
      </ng-template>
    </div>
  `,
    styles: [
        `
      .side-border {
        border-left: 1px solid rgba(0, 0, 0, 0.12);
        height: 100%;
        padding-left: 16px;
      }

      .list-item {
        padding-bottom: 0px;
      }

      .claimListDialog {
        width: 80%;
        height: auto;
        min-height: 'calc(100vh - 90px)';
      }
    `,
    ],
    standalone: false
})
export class RemindersComponent
  extends BaseComponent
  implements OnInit, AfterViewInit {
  currentUserName: string;
  hasReportClaim: boolean = false;
  hasLearningCenter: boolean = false;
  outboundSSO: OutboundSSO[] = [];
  hasClaims: boolean = false;
  isLoaded: boolean = false;
  hasReminders: boolean = false;
  isIncidentalClient: boolean = false;
  maxBadgeCount = 99;
  mappings: any;
  filterData: NotificationItem[] = [];
  claimCount: number;
  trigger: string;
  userReminder: Reminder[];
  initialNotifications: NotificationItem[] = [];
  redirectToSmartly: boolean = true;
  @Input()
  showPaymentAlert: boolean;
  imageName: string = './assets/images/';

  @Input()
  setToastButnShow: Observable<boolean>;

  hasOpenClaims: boolean = false;
  multipleOpenClaims: boolean = false;

  @ViewChild('dynamicContentContainer1') container: ElementRef;
  @ViewChild('dialogSelectClaim') dialogSelectClaim: TemplateRef<any>;
  @ViewChild('dialogReportNewClaim') dialogRefReportNewClaim: TemplateRef<any>;

  @Output()
  valueChanged = new EventEmitter<boolean>();

  @Output()
  focusTab = new EventEmitter<string>();

  @Output()
  filterApplied = new EventEmitter<boolean>();

  @Input()
  myClaims: MyClaim[];

  @Input()
  commCenterMsgCount: number = 0;

  @Input()
  activitiesMyClaims: any;

  @Input()
  mgrAction: UserActions | null;

  @Input()
  myclaimsLoaded: boolean = false;

  @Input()
  translationRequest: TranslationRequest;

  claimkey: any[];
  lobs: any = [];
  lobmyclaims = ['PR', 'AU', 'GL'];
  lobExist: boolean = false;
  isManager: boolean = false;
  terminated: boolean = false;
  isMgrOwnClaims: boolean = false;
  claimant: IClaimant | null;
  isController: boolean = false;
  reportClaimLabel: string = '';
  incidentalAbsences5: boolean = false;
  messageString: string = '';
  messageString1: any;
  hasBothLinks: boolean;
  hasOnlyLearningLink: boolean;
  private unlistens: (() => void)[] = [];
  constructor(
    public session: Session,
    public dialog: MatDialog,
    public userRole: UserRoleService,
    public display: DisplayService,
    public claimConfigService: ConfigurationService,
    private router: Router,
    public logService: LogService,
    private userAction: UserActionService,
    public outboundSsoService: OutboundSsoService,
    public commCenterService: CommCenterService,
    private route: ActivatedRoute,
    public claimService: ClaimService,
    public inpageAliasService: InpageAliasService,
    private bindEvents: DynamicEventBindService,
    private leaveLinkAccessService: LeaveLinkAccessService
  ) {
    super();
  }

  async ngOnInit() {
    this.mappings = [
      {
        selector: '.learning-center',
        action: this.redirectToLearningCenter.bind(this),
      },
      {
        selector: '.report-claim',
        action: this.bindReportClaim.bind(this),
      },
    ];
    this.hasReportClaim = this.display.reportClaim;
    this.hasLearningCenter = this.display.learningCenter;
    this.terminated = this.session.user.emulatorContext?.isTerminated;
    this.isManager = this.userRole.manager;
    this.isMgrOwnClaims = this.route.snapshot.queryParamMap.get('emp') == null; //this.mgrAction == UserActions.ViewOwnEmpDb;
    this.myClaims.forEach((element) => this.lobs.push(element.lineOfBusiness));
    this.lobExist = this.lobs.every((value: string) => {
      return this.lobmyclaims.includes(value);
    });
    this.outboundSSO = this.display.outboundSSO;
    this.hasClaims = this.myClaims && this.myClaims.length > 0 ? true : false;
    this.hasReminders =
      this.activitiesMyClaims?.reminder &&
        this.activitiesMyClaims.reminder.filter(
          (n: any) => n.reminderMessage != null && n.reminderMessage != undefined
        ).length > 0
        ? true
        : false;
    this.reportClaimLabel = this.activitiesMyClaims.reportClaimLabel;

    this.checkOpenClaims();
    this.isLoaded = true;

    if (this.userRole.manager) {
      this.mgrAction = this.userAction.getAction();
      if (this.mgrAction == UserActions.MgrViewEmpDb) {
        this.claimant = this.userAction.getClaimant();
        this.currentUserName = this.session.user?.firstName;
      }
      if (this.mgrAction == UserActions.ViewOwnEmpDb) {
        this.userAction.removeClaimant();
        this.currentUserName = this.session.user?.firstName;
      }
    } else if (this.userRole.controller) {
      this.userAction.removeClaimant();
      this.currentUserName = this.session.user?.firstName;
    } else {
      this.currentUserName = this.session.user?.firstName;
    }

    this.initialNotifications = this.activitiesMyClaims.notifications;
    this.incidentalAbsences5 = this.claimConfigService.getConfigFeatureAccess(
      'IncidentalAbsences5'
    );

    if (this.isManager && !this.isMgrOwnClaims) {
      this.imageName =
        this.imageName + '053726-mySedgwick_Helpful_Link_Characters_4.png';
    } else if (this.isMgrOwnClaims || !this.isManager) {
      this.imageName =
        this.imageName + 'mySedgwick_Helpful_Link_Characters_3.webp';
    }

    this.isLoaded = true;
  }

  ngAfterViewInit(): void {
    this.unlistens = this.bindEvents.bindDynamicEvents(
      this.container,
      this.mappings
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  bindReportClaim(event: any) {
    this.quickLinksClick('ReportNewClaim', 'Report New Claim');
  }

  openClaimSummary(reminder: Reminder) {
    const claim = reminder.importantRemainders?.[0];
    if (!claim?.claimId || !claim?.source) {
      return;
    }

    this.FeatureLogging(
      'ImportantReminder',
      'INVENTORY_UNSUBMITTED - Claim',
      'Reminder'
    );

    this.router.navigate(['claims'], {
      queryParams: {
        claimId: claim.claimId,
        source: claim.source,
      },
    });
  }

  openInventoryReminder(reminder: Reminder) {
    const claim = reminder.importantRemainders?.[0];
    if (!claim?.claimId || !claim?.source) {
      return;
    }

    this.FeatureLogging(
      'ImportantReminder',
      'INVENTORY_UNSUBMITTED',
      'Reminder'
    );

    this.router.navigate(['inventory-submission'], {
      queryParams: {
        claimId: claim.claimId,
        source: claim.source,
      },
    });
  }

  getClaimDetails(triggerName: string, count: number) {
    this.FeatureLogging(
      'ImportantReminder',
      triggerName + ' - Count = ' + count,
      'Reminder'
    );
    this.activitiesMyClaims.notifications = this.initialNotifications;
    for (let rem = 0; rem < this.activitiesMyClaims?.reminder.length; rem++) {
      const arrItem = this.activitiesMyClaims?.reminder[rem];
      if (arrItem.alertType != 'PaymentAlert') {
        if (arrItem && arrItem?.importantRemainders != undefined) {
          this.claimkey = arrItem?.importantRemainders.map((claimData: any) => {
            return {
              claimId: claimData.claimId,
              claimNumber: claimData.claimNumber,
              source: claimData.source,
            };
          });
        }

        if (triggerName == arrItem?.alertType) {
          if (count == 1) {
            const currentAlert = this.activitiesMyClaims.notifications.find(
              (n: any) => n.type === triggerName
            );

            const triggerKey = `${currentAlert.type}_${currentAlert.claimNumber}_${currentAlert.source}`;

            sessionStorage.removeItem('triggerKey');
            sessionStorage.removeItem('alertMasterId');
            sessionStorage.setItem('triggerKey', triggerKey);
            sessionStorage.setItem('alertMasterId', currentAlert.alertId);
            switch (triggerName) {
              case 'RTW_CONFIRM_NEEDED_A':
                this.router.navigate(['confirm-return-to-work'], {
                  queryParams: {
                    claimId: this.claimkey[0].claimId,
                    source: this.claimkey[0].source,
                    alertMasterUid: currentAlert.alertId,
                    lob: currentAlert.lob,
                    claimNumber: currentAlert.claimNumber,
                    rtw: 'confirm',
                    rtwType: arrItem.notificationMessage
                      .toLowerCase()
                      .includes('full')
                      ? 'Full'
                      : arrItem.notificationMessage
                        .toLowerCase()
                        .includes('restricted')
                        ? 'Restricted'
                        : null,
                    rtwDate: currentAlert.date.toString(),
                  },
                });

                break;
              case 'MEDDOC_NEEDED_A':
                this.router.navigate(['/upload-documents-in-documentstab'], {
                  queryParams: {
                    focus: 'documents',
                    source: this.claimkey[0].source,
                    claimId: this.claimkey[0].claimId,
                    showDialog: true,
                  },
                });
                break;
              case 'MEDDOC_RCVD_A':
                this.filterNotifications(this.claimkey, triggerName);
                break;
              case 'CLINICAL_REVIEW_SENT_A':
                this.filterNotifications(this.claimkey, triggerName);
                break;
              default:
            }
          }
          if (count > 1) {
            this.filterNotifications(this.claimkey, triggerName);
          }
        }
      }
    }
  }

  filterNotifications(claimkey: any[], triggerName: string) {
    this.isLoaded = false;
    let filteredNotifications: NotificationItem[] = [];
    filteredNotifications = this.activitiesMyClaims?.notifications.filter(
      (x: NotificationItem) => x.type === triggerName
    );
    if (filteredNotifications.length > 0) {
      this.activitiesMyClaims.notifications = [...filteredNotifications];
    }
    const notificationElement = document.getElementById('myclaimspnl');
    if (notificationElement != null) {
      notificationElement.scrollIntoView();
    }
    this.filterApplied.emit(true);
    this.focusTab.emit('Notifications');
    this.isLoaded = true;
  }

  showReportAbsence() {
    return (
      this.myClaims.findIndex(
        (claim) =>
          claim.status === 'Open' &&
          claim.lineOfBusiness === 'LV' &&
          claim.isIntermittent &&
          claim.claimLevelFeatures.indexOf('submitintermittentabsences') > -1
      ) > -1 && this.display.reportIntermittentAbsence
    );
  }

  quickLinksClick(featureName: string, tabName: string, ssoType: string = '') {
    let ssoLabel = ' - ';

    if (this.outboundSSO != null && ssoType != undefined && ssoType != null && ssoType.length > 2) {
      ssoLabel = ssoLabel + ssoType.toUpperCase();
    }

    tabName = tabName + (featureName == 'OutboundSSO' ? ssoLabel : '');
    this.FeatureLogging(featureName, tabName, 'View QuickLinks');

    if (featureName == 'ReportNewClaim') {
      this.reportClaim();
    } else if (featureName == 'ReportAbsence') {
      this.selectClaim();
    } else if (featureName == 'ViewAbsences') {
      this.navigateToAbsences();
    } else if (featureName == 'CommunicationCenter') {
      this.router.navigate(['/communication-center'], {});
    } else if (featureName == 'LearningCenter') {
      this.redirectToLearningCenter(null);
    } else if (featureName == 'OutboundSSO') {
      if (this.outboundSSO != undefined && this.outboundSSO != null && this.outboundSSO.length > 0) {
        const ssoIndex = this.outboundSSO.findIndex(x => x.ssoType.toLowerCase() == ssoType.toLowerCase());
        if (ssoIndex > -1) {
          if (ssoType.toLowerCase() === 'leavelink') {
            this.leaveLinkAccessService.handleLeaveLinkAccess();
          } else {
           this.outboundSsoService.showConfirmationDialog(
              this.outboundSSO[ssoIndex].ssoType,
              this.outboundSSO[ssoIndex].ssoEndPoint
            );
           
          }
        }
      }
    }
  }

  async reportClaim() {
    if (
      ((this.userRole.manager &&
        this.display.mgrAction == UserActions.ViewOwnEmpDb) ||
        !this.userRole.manager) &&
      this.showReportAbsence() &&
      !this.claimConfigService.getConfigFeatureAccess('leavelinksso')
    ) {
      this.dialog.open(this.dialogRefReportNewClaim, {
        panelClass: 'claimListDialog',
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Confirmation',
      };
      const dlg = this.dialog.open(ReportNewClaimComponent, dialogConfig);
      dlg.addPanelClass('app-dlg-padding');
      dlg.updateSize('700px', '450px');
    }
  }

  checkOpenClaims() {
    let count: number = 0;
    this.myClaims.forEach(function (claim) {
      if (
        claim.status === 'Open' &&
        claim.lineOfBusiness === 'LV' &&
        claim.claimDescription.toLowerCase().indexOf('intermittent') > -1
      ) {
        count++;
      }
    });
    if (count > 0) {
      this.hasOpenClaims = true;
    }
    if (count > 1) {
      this.multipleOpenClaims = true;
    }
  }

  selectClaim() {
    if (this.claimConfigService.getConfigFeatureAccess('leavelinksso')) {
      this.claimService.loadIntermittentAbsence('', '', null);
    } else {
      if (this.hasOpenClaims) {
        if (this.multipleOpenClaims) {
          this.redirectToSmartly = false;
          this.dialog.open(this.dialogSelectClaim, {
            panelClass: 'claimListDialog',
          });
        } else {
          //const queryParams: any = {};
          const element = this.myClaims.find(
            (claim) =>
              claim.status === 'Open' &&
              claim.lineOfBusiness === 'LV' &&
              claim.claimDescription.toLowerCase().indexOf('intermittent') > -1
          );
          /*         queryParams.claimId = element.claimId;
        queryParams.source = element.source;
        this.userAction.setClaimant(element);
        this.router.navigate(['/reportanabsence'], {
          queryParams,
        }); */
          this.claimService.loadIntermittentAbsence(
            element.claimId,
            element.source,
            this.router
          );
        }
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  redirectToLearningCenter(event: MouseEvent) {
    this.route.url.subscribe((urlSegments) => {
      if (urlSegments.length > 0) {
        const firstPathSegment = urlSegments[0].path;
        this.router.navigate(['help'], {
          queryParams: {
            focus: 'learningcenter',
            origin: firstPathSegment,
          },
        });
      }
    });
  }

  getReminderAriaLabel(alertType: string): string | null {
    switch (alertType) {
      case 'MEDDOC_RCVD_A':
        return 'Supporting documentation has been received';
      case 'MEDDOC_NEEDED_A':
        return 'Supporting documentation is required';
      case 'RTW_CONFIRM_NEEDED_A':
        return 'confirmation of return to work date is required.';
      case 'CLINICAL_REVIEW_SENT_A':
        return 'which have been referred to clinical review';
      case 'CLARIFICATION_DUE_A':
        return 'clarification is due';
      case 'CLARIFICATION_RCVD_A':
        return 'clarification has been received';
      case 'INITIAL_PACKET_SENT_A':
        return 'initial packet has been sent';
      default:
        return null;
    }
  }

  navigateToAbsences() {
    this.router.navigate(['/absence-dashboard'], {
      queryParams: {
        focus: 'my',
      },
    });
  }
}
